import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

// dayjs bug: startOf/endOf/add on a tz instance can pick the DEVICE offset (e.g. +06:30 in New York). Re-anchor to the zone.
const fix = (name) => {
  const orig = dayjs.prototype[name];
  dayjs.prototype[name] = function (...a) {
    const z = this.$x && this.$x.$timezone;
    const r = orig.apply(this, a);
    return z && dayjs.isDayjs(r) ? dayjs.tz(r.format("YYYY-MM-DDTHH:mm:ss.SSS"), z) : r;
  };
};
["startOf", "add", "subtract"].forEach(fix);

// Business time zone: every booking date/time shows in business time whatever the device time zone is.
export const BIZ_TZ = "Asia/Kolkata";
const NAIVE = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}(:\d{2}(\.\d+)?)?)?$/;

export default function bizday(d, ...rest) {
  if (rest.length) return dayjs(d, ...rest);
  if (d === undefined) return dayjs().tz(BIZ_TZ);
  if (d === null || d === "") return dayjs(d);
  if (dayjs.isDayjs(d)) return d;
  if (typeof d === "string" && NAIVE.test(d)) return dayjs.tz(d, BIZ_TZ);
  return dayjs(d).tz(BIZ_TZ);
}
Object.assign(bizday, dayjs);

export const bizYmd = (d = new Date()) => new Date(d).toLocaleDateString("en-CA", { timeZone: BIZ_TZ });
